const convertToDecimal = (num, digits = 1) => {
  var rounded = Math.pow(10, digits);
  return (Math.round(num * rounded) / rounded).toFixed(digits);
};

export { convertToDecimal };
